import React, { Component } from 'react';
import { Button, Col, Label, Row } from 'reactstrap'
import { observer } from "mobx-react";
import { FiltroDefault, FiltroImpExp, FiltroArmador } from "./filtros/FiltrosPerfil"
import { Filtro, FecharFiltro } from '../../../comum/components/Icones'
import Card from '../../../comum/components/Card'
import lscache from "lscache";

@observer
export class FiltrosMovimentacao extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        this.renderFiltros = this.renderFiltros.bind(this);
        this.renderBotaoMaisFiltros = this.renderBotaoMaisFiltros.bind(this);
        this.maisFiltros = lscache.get('movimentacao-maisFiltros');
        this.state = { maisFiltros: this.maisFiltros ? this.maisFiltros : false };
    }

    filtrar() {
        this.controller.pesquisar()
    }

    renderFiltros() {
        //Não pode ser um switch case, pois há uma questão de ordem segundo o cliente sobre existência no array de perfis (este array é dinâmico)
        if (this.controller.perfilUsuario.includes('ARMADOR') || this.controller.perfilUsuario.includes('CONSULTAS') || this.controller.perfilUsuario.includes('ATENDIMENTO')) {
            return <FiltroArmador controller={this.controller} filtro={this.state.maisFiltros} />
        } else
            if (process.env.rig) return <FiltroImpExp controller={this.controller} />
            else {
                return <FiltroDefault controller={this.controller} filtro={this.state.maisFiltros} />
            }
    }

    renderBotaoMaisFiltros() {
        if(process.env.rig) { //Fluig: 1675166 Liberado a opção de Mais Filtros aos perfis (CONSULTAS e ATENDIMENTO).
            if(this.controller.perfilUsuario.includes('ARMADOR') || this.controller.perfilUsuario.includes('CONSULTAS') || this.controller.perfilUsuario.includes('ATENDIMENTO')) {
                if(this.state.maisFiltros) {
                    return (<Button className="btn-filtros ativo" onClick={() => this.mudaFiltros()} outline>
                        <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
                                Menos filtros
                    </Button>)
                } else {
                    return (<Button className="btn-filtros " onClick={() => this.mudaFiltros()} outline>
                        <Filtro color="#93A0AD" className="mr-2" width="15" height="15" />
                            Mais filtros
                    </Button>)
                }
            } else {
                return null;
            }
        } else {
            if(this.state.maisFiltros) {
                return (<Button className="btn-filtros ativo" onClick={() => this.mudaFiltros()} outline>
                    <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
                            Menos filtros
                </Button>)
            } else {
                return (<Button className="btn-filtros " onClick={() => this.mudaFiltros()} outline>
                    <Filtro color="#93A0AD" className="mr-2" width="15" height="15" />
                        Mais filtros
                </Button>)
            }
        }
    }

    mudaFiltros = () => {
        this.setMaisFiltros(!this.state.maisFiltros);
        this.setState({ maisFiltros: !this.state.maisFiltros });
    };

    setMaisFiltros(bool) {
        lscache.set('movimentacao-maisFiltros', bool, 5);
    }

    render() {

        return (
            <Card>
                <div className="filtros">
                    <Row className="align-items-end">

                        {this.renderFiltros()}

                        <Col xs={12} className="mb-4 mr-2" style={{ alignItems: "flex-end" }}>
                            <div className="mr-3">
                                <Col xs={12} className="col-label px-0">
                                    <Label>Visualização</Label>
                                </Col>
                                <Col xs={12} className="px-0">
                                    <Button className="btn-filtros" onClick={this.props.clickBtnFiltros} outline>
                                        <Filtro color="#93A0AD"
                                            className="mr-2"
                                            width="15"
                                            height="15" />
                                        Customizar
                                    </Button>
                                </Col>
                            </div>
                            {
                                this.renderBotaoMaisFiltros()
                            }
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.filtrar()}>Filtrar</Button>
                        </Col>
                    </Row>
                    {
                    !process.env.rig &&
                        <Row>
                            <Col>
                                Dados disponíveis para simples conferência, conforme consignatário da BL master. Caso identifiquem divergências, acione a nossa equipe de Atendimento.
                            </Col>
                        </Row>
                    }
                </div>
            </Card>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/components/FiltrosMovimentacao.js